import React, { createContext, useContext, useState, useCallback, useEffect, useMemo } from "react";
import * as en from "../data/mock";
import * as es from "../data/mock.es";
import { approvedContent } from "../data/approved-content";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('lawyah_lang') === 'es' ? 'es' : 'en');

  const setLanguage = useCallback((l) => {
    if (!['en', 'es'].includes(l)) return;
    setLang(l);
    localStorage.setItem("lawyah_lang", l);
  }, []);

  const t = useMemo(() => approvedContent(lang === "es" ? es : en, lang), [lang]);
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  const value = useMemo(() => ({ lang, setLanguage, t }), [lang, setLanguage, t]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
